export const TEXT = 'TEXT'
export const SELECT = 'SELECT'
export const RADIO = 'RADIO'
export const MARKDOWN = 'MARKDOWN'
export const CHECKBOX = 'CHECKBOX'
export const SWITCH = 'SWITCH'
export const FILE = 'FILE'
export const TYPOGRAPHY = 'TYPOGRAPHY'
export const EMPTY_COLUMN = 'EMPTY_COLUMN'

export const VIDEO_FILE = 'VIDEO_FILE'
export const IMAGE_FILE = 'IMAGE_FILE'

export const fileExts = {
    "allVideos": "video/*",
    "imagePngJpg": 'image/png, image/jpeg',
    "imageAll": 'image/*',
    "pdf": '.pdf',
    "msXL": '.xlsx, .xls, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
}

export const getFileDetailsByExt = ext => {
    // other file types
    const pdf = ['pdf']
    const data = ['xlsx', 'xls', 'csv']


    // @todo -> Need this from backend
    const formatTypes = [
        {
            type: IMAGE_FILE,
            formats: ['jpg', 'jpeg', 'png', 'webp'],
            accept: 'image/png, image/jpeg'
        },
        {
            type: VIDEO_FILE,
            formats: ['mp4', 'mkv', 'mov'],
            accept: 'video/*'
        }
    ]

    let fileDetails = null;
    for (let i = 0; i < formatTypes.length; i++) {
        const eachFormat = formatTypes[i];

        if (eachFormat.formats.findIndex(format => format === ext) > -1) {
            fileDetails = {
                type: eachFormat.type,
                accept: eachFormat.accept
            }
            break;
        }

    }
    return fileDetails
}